import axios, { AxiosResponse } from 'axios';

import { TCalculationActiveInfo, TCalculationInfoParams, TCalculationLog } from '../types/calculation-common';

import { TPageMetadataWithItems } from '@/types/meta';

const BASE_URL = '/api/loaders';

export default {
  startGasRecalculation: function (): Promise<AxiosResponse<string>> {
    return axios.post(`${BASE_URL}/gas-recalculation/start`);
  },
  startDbfRecalculation: function (files: FormData): Promise<AxiosResponse<string>> {
    return axios.post(`${BASE_URL}/dbf-loader/start`, files);
  },
  startWeeklyRecalculation: function (files: FormData): Promise<AxiosResponse<string>> {
    return axios.post(`${BASE_URL}/weekly/start`, files);
  },
  startNsiRecalculation: function (files: FormData): Promise<AxiosResponse<string>> {
    return axios.post(`${BASE_URL}/nsi/start`, files);
  },
  getLogs: function (processingId: string, afterId?: number): Promise<AxiosResponse<TCalculationLog[]>> {
    return axios.get(`${BASE_URL}/${processingId}/logs`, { params: { afterId } });
  },
  getCalculationActiveInfo: function (): Promise<AxiosResponse<TCalculationActiveInfo>> {
    return axios.get(`${BASE_URL}/active`);
  },
  getCalculationInfo: function (
    params: TCalculationInfoParams,
    abortController?: AbortController,
  ): Promise<AxiosResponse<TPageMetadataWithItems<TCalculationActiveInfo>>> {
    return axios.get(BASE_URL, { params, signal: abortController?.signal });
  },
};
